import { Box } from '@mui/material';

export interface EditCardThumbnailProps {
  /** Public URL of the edit preview image (same asset is used for backdrop and foreground). */
  src: string;
}

/**
 * 16:9 thumbnail using "broadcast blur": a sharp `object-fit: contain` image over a blurred,
 * scaled-up copy of the same image so pillarbox areas (vertical video in a horizontal frame) stay filled.
 */
export function EditCardThumbnail({ src }: EditCardThumbnailProps) {
  return (
    <Box
      sx={{
        position: 'relative',
        aspectRatio: '16/9',
        bgcolor: (theme) =>
          theme.palette.mode === 'dark' ? theme.palette.grey[800] : theme.palette.grey[100],
        overflow: 'hidden',
        // Keep internal z-index (sharp img over blur) from stacking above sibling overlays.
        isolation: 'isolate',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          backgroundImage: `url(${JSON.stringify(src)})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          transform: 'scale(1.15)',
          filter: (theme) => `blur(${theme.spacing(2.5)})`,
        }}
      />
      <Box
        component="img"
        src={src}
        alt=""
        sx={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          zIndex: 1,
        }}
      />
    </Box>
  );
}
